/** Iter 108 — permanent banner while an admin is impersonating a
 * vendor/customer (cookie-based full impersonation), with instant
 * "Return to Admin Dashboard". Distinct from the older header-based
 * view-as-vendor banner. */
import { useEffect, useState } from "react";
import api from "@/lib/api";
import { ShieldAlert, LogOut } from "lucide-react";

export default function AdminImpersonationBanner() {
  const [info, setInfo] = useState(null);

  useEffect(() => {
    api.get("/auth/me").then((r) => {
      const u = r.data?.user || r.data;
      if (u?.impersonated_by) setInfo(u);
    }).catch(() => {});
  }, []);

  if (!info) return null;

  const exit = async () => {
    try { await api.post("/admin/impersonate/exit"); } catch { /* idempotent */ }
    window.location.assign("/dashboard/admin");
  };

  return (
    <div className="sticky top-0 z-[100] bg-rose-600 text-white px-3 py-2 flex items-center justify-between gap-3 shadow-lg" data-testid="admin-impersonation-banner">
      <div className="flex items-center gap-2 min-w-0 text-sm font-bold">
        <ShieldAlert className="h-4 w-4 shrink-0" />
        <span className="truncate">Admin Mode — Viewing as: {info.real_name || info.name} ({info.role})</span>
      </div>
      <button type="button" onClick={exit} className="shrink-0 inline-flex items-center gap-1.5 rounded-full bg-white text-rose-700 text-xs font-bold px-3 py-1.5 hover:bg-rose-50" data-testid="impersonation-exit-btn">
        <LogOut className="h-3.5 w-3.5" /> Return to Admin Dashboard
      </button>
    </div>
  );
}

/** Shared helper: start impersonation and jump into the target's dashboard. */
export async function impersonate(userId, role) {
  await api.post(`/admin/impersonate/${userId}`);
  window.location.assign(role === "customer" ? "/dashboard/customer" : "/dashboard/vendor");
}
